import { makeStyles } from "tss-react/mui";

import { Theme, Typography } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        width: "100%",
        alignItems: "center",
    },
    outlineBox: {
        height: "10px",
        backgroundColor: theme.palette.emteria.border.primary,
        borderRadius: 50,
        display: "flex",
        width: "100%",
        overflow: "hidden",
    },
    progress: {
        borderRadius: 50,
        height: "100%",
        transition: "width 0.3s ease",
    },
    progressPercentage: {
        paddingLeft: theme.spacing(1),
    },
}));

const getFormattedProgress = (progressNumber: number) => {
    if (progressNumber === 100) {
        return "100%";
    } else if (progressNumber > 0 && progressNumber < 1) {
        return "1%";
    } else {
        return `${Math.floor(progressNumber)}%`;
    }
};

interface Props {
    progress: number;
    color?: string;
    hideLabel?: boolean;
}

export const ProgressBar = ({ progress, color, hideLabel }: Props) => {
    const { classes } = useStyles();

    return (
        <div className={classes.container} data-testid="progress-bar">
            <div className={classes.outlineBox}>
                <div className={classes.progress} style={{ width: `${progress}%`, backgroundColor: color }} />
            </div>
            <Typography className={classes.progressPercentage}>
                {hideLabel ? "\u00A0" : getFormattedProgress(progress)}
            </Typography>
        </div>
    );
};
